import JraMembershipOptions from './JraMembershipOptions';
import { parents } from '../../../../util/dom';
import { dispatchInputChangeEvent, isCustomValidInput } from '../helpers';
import { SECTION_EXPANDED_CLASS, OVERSEAS_CLASS } from '../constants';


export default class JraJoinMembershipOptions extends JraMembershipOptions {
  static JOIN_MEMBERSHIP_TYPE_CHANGE_EVENT = 'joinMembershipTypeChangeEvent';

  static JOIN_SUBSCRIPTION_TYPE_CHANGE_EVENT = 'joinSubscriptionTypeChangeEvent';

  constructor(element, encodeDecodeKey) {
    super(element, encodeDecodeKey);

    this.element = element;

    this.toggleMembershipType = this.toggleMembershipType.bind(this);
    this.initJraJoinMembershipOptions();
  }


  initJraJoinMembershipOptions() {
    this.subscriptionTypeRadioButtons = [...this.element.querySelectorAll('[data-jra-membership-subscription-type-radio-button]')];

    this.subscriptionTypeRadioButtons.forEach((button) => {
      button.addEventListener('change', () => {
        this.setActiveButton(button);
        const membershipType = button.id;
        this.emit(JraJoinMembershipOptions.JOIN_SUBSCRIPTION_TYPE_CHANGE_EVENT, membershipType);


        // This will only pick up the first one which is uk
        const hiddenInput = this.element.querySelector('[data-jra-membership-type-radio-group-hidden-input]');
        hiddenInput.value = button.value; // Digital or Paper
        isCustomValidInput(hiddenInput);
        dispatchInputChangeEvent(hiddenInput);
      });
    });

    const isOverseasForm = this.element.querySelector('[data-jra-membership-type-overseas-default]').dataset.jraMembershipTypeOverseasDefault.toLowerCase() === 'true';
    if (isOverseasForm) {
      this.presetOverseas();
    } else {
      this.presetUK();
    }
  }


  /**
   * Completely overwritten from JoinMembershipOption as this targets subscription radio buttons
   */
  toggleMembershipType(event) {
    const radioButton = event.currentTarget;
    const location = radioButton.value;
    // get hidden input relating to relevant radio list

    // this is the hidden validation field that relates to subscription type not the membership type btw,
    // there is no hidden validation relating to that input
    const hiddenInput = this.element.querySelector(`[data-jra-membership-type-radio-group-hidden-input="${location}"]`);
    hiddenInput.value = ''; // reset value so validation is reset

    this.membershipName = this.requiredValidationMessage;
    this.membershipPrice = 0;

    // the setting of the overseas modifier is used throughout the form.
    if (radioButton.value === 'Overseas' && radioButton.checked && !this.form.classList.contains(OVERSEAS_CLASS)) {
      this.form.classList.add(OVERSEAS_CLASS);
    } else if (radioButton.value !== 'Overseas' && radioButton.checked && this.form.classList.contains(OVERSEAS_CLASS)) {
      this.form.classList.remove(OVERSEAS_CLASS);
    }

    if (this.addressInputs.length > 0) {
      this.resetAddressFields();
    }

    // adding active has no style affect but serves to activate and deactivate validation
    this.membershipRadioLists.forEach((radioList) => {
      // set selected radioList to active
      if (radioList.dataset.jraMembershipRadioList === location) {
        radioList.classList.add(SECTION_EXPANDED_CLASS);

        const localizedSubscriptionTypeRadioButtons = [...radioList.querySelectorAll('[data-jra-membership-subscription-type-radio-button]')];
        // reset all payment radio buttons
        this.setActiveButton(null);

        // pre select payment control if only one choice
        if (localizedSubscriptionTypeRadioButtons.length === 1) {
          const control = localizedSubscriptionTypeRadioButtons.pop();
          control.checked = true;
          hiddenInput.value = control.value;
          dispatchInputChangeEvent(control);
        }
      } else {
        radioList.classList.remove(SECTION_EXPANDED_CLASS);
      }
    });

    if (this.membershipType && this.membershipType !== radioButton.value) {
      this.membershipType = radioButton.value;

      this.emit(JraMembershipOptions.EVENT_CHANGE, location, hiddenInput);
    }

    radioButton.checked = true;
    isCustomValidInput(hiddenInput); // validate the location
    dispatchInputChangeEvent(hiddenInput);

    this.emit(JraJoinMembershipOptions.JOIN_MEMBERSHIP_TYPE_CHANGE_EVENT, event);
  }


  /**
   * Sets checked and active class for subscription radio buttons
   */
  setActiveButton = (input) => {
    this.subscriptionTypeRadioButtons.forEach((button) => {
      const radioControls = parents(button, '[data-jra-membership-radio-control]');
      const radioControl = radioControls.shift();
      radioControl.classList.remove('active');
      if (button.checked === true) {
        button.checked = false;
      }

      if (button === input) {
        button.checked = true;
        radioControl.classList.add('active');
      }
    });
  }
}
